import ApiService from '../apiservice'

export default class ArquivoProcessoService extends ApiService {
  constructor() {
    super('/arquivoProcesso')
  }

  incluirArquivo(formData) {
    return this.post('/',formData);
  }

  listarArquivos(processo,classificacao,ordencacao) {
    return this.get(`/consultarArquivos/${processo}/${classificacao}/${ordencacao}`);
  }

  consultarArquivo(codigo) {
    return this.get(`/consultarArquivo/${codigo}`);
  }

  adicionarDescricao(arquivo) {
    return this.put(`/adicionarDescricao/${arquivo.codigo}`, arquivo);
  }

  excluirArquivo(codigo) {
    return this.delete(`/excluirArquivo/${codigo}`);
  }

  download(codigoProcesso,fileName) {
    return this.get2(`/download/${codigoProcesso}/${fileName}`);
  }

  exibirArquivo(file,codigo) {
    return this.get2(`/arquivo/exibir?nome=${file}&codigoProcesso=${codigo}`);
  }

	baixarTodosArquivos(processoId) {
		return this.get2(`/baixar-arquivos/${processoId}`);
	}
}